// src/components/CalledNumbers.tsx

import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {useGame} from '../contexts/GameContext';
import {useMute} from "../contexts/MuteContext";
import BulbCircle from "./bulb";
import {audioEngine} from "./audioMap";
import {TimepassSDK} from "../assets/images/TimepassAPI/TimepassSDK";

export const getSequentialColor = (index: number) => {
    const colors = [
        {bg: '#91AF4D', border: '#87d889'},
        {bg: '#72BCC2', border: '#02838F'},  // Blue
        {bg: '#CA3B2C', border: '#732727'},  // Red
        {bg: '#953B63', border: '#723037'},  // Purple

    ];
    // For the first number, return yellow with green border
    if (index === 0) {
        return {bg: '#E1B132', border: '#45EE6A'};  // Yellow and Green for first number
    }
    return colors[(index - 1) % colors.length];  // Cycle through the color array for subsequent numbers
};


export const getSequentialColor2 = (index: number) => {
    const colors = [
        {bg: '#91AF4D', border: '#487149'},
        {bg: '#72BCC2', border: '#02838F'},  // Blue
        {bg: '#d89789', border: '#732727'},  // Red
        {bg: '#953B63', border: '#723037'},  // Purple

    ];
    // For the first number, return yellow with green border
    if (index === 0) {
        return {bg: '#E1B132', border: '#45EE6A'};  // Yellow and Green for first number
    }
    return colors[(index - 1) % colors.length];  // Cycle through the color array for subsequent numbers
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
`;

const NumbersRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center; /* Ensure numbers are vertically aligned */
    gap: 7px;
    margin-top: 10px;
    overflow: hidden;
    width: 100%;
    max-width: 400px;
    padding: 5px;
`;
const NumberBubbleWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const NumberBubble = styled.div<{
    isNew?: boolean,
    randomColor: { bg: string, border: string },
    isFirst: boolean,
    bg: string
}>`
    padding: 10px;
    width: ${props => props.isFirst ? '75px' : '45px'};
    height: ${props => props.isFirst ? '75px' : '45px'};
    border-radius: 50%;
    background-image: url(${props => props.bg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.isNew ? "24px" : "14px"};
    font-weight: bold;
    position: relative;
    box-shadow: ${props => props.isNew ? '0 4px 6px rgba(0, 0, 0, 0.1)' : '0 3px 5px rgba(0, 0, 0, 0.2)'};
    transition: background 0.3s ease;

    svg {
        position: absolute;
        top: -7%;
        left: -7%;
        transform: rotate(-90deg);
        width: 114%;
        height: 114%;
        z-index: 1;
        pointer-events: none;
    }

    circle {
        fill: none;
        stroke: #45EE6A;
        stroke-width: 4;
        stroke-dasharray: 283;
        stroke-dashoffset: 283;
        ${props => props.isNew && `
animation: ringProgress 4.5s linear ease-in-out;
        `}
    }

    @keyframes popIn {
        0% {
            transform: scale(0) rotate(0deg);
            opacity: 0;
        }
        50% {
            transform: scale(1) rotate(-180deg);
            opacity: 0.7;
        }
        100% {
            transform: scale(1) rotate(0deg);
            opacity: 1;
        }
    }

    @keyframes ringProgress {
        0% {
            stroke-dashoffset: 283;
        }
        50% {
            stroke-dashoffset: 141.5;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
`;


const BulbAnimationWrapper = styled.div`
    .bulb-circle {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: 10000000000000000;
    }

    .bulb {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        position: absolute;
        animation: blink 2s infinite;
        z-index: 10000000000000000;
    }


    ${[...Array(8)].map((_, i) => {
        const angle = (360 / 8) * i;
        const radians = (angle * Math.PI) / 180;
        const radius = 29;
        const x = 50 + radius * Math.cos(radians) - 4;
        const y = 50 + radius * Math.sin(radians) - 4;
        const delay = i % 2 === 0 ? '0s' : '1s'; // alternate delay
        return `
      .bulb-${i} {
        left: ${x}px;
        top: ${y}px;
        animation-delay: ${delay};
        background-color: yellow;
      }
    `;
    }).join('\n')} @keyframes blink {

    0%, 100% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }
}
`;


const BulbAnimationWrapper2 = styled.div<{
    color: string
}>`
    .bulb-circle-2 {
        position: absolute;
        width: 100px;
        height: 100px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: 10000000000000000;
    }


    .bulb-2 {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        position: absolute;
        animation: blink 2s infinite;
        z-index: 10000000000000000;
    }

    ${[...Array(8)].map((_, i) => {
        const angle = (360 / 8) * i;
        const radians = (angle * Math.PI) / 180;
        const radius = 29;
        const x = 50 + radius * Math.cos(radians) - 4;
        const y = 50 + radius * Math.sin(radians) - 4;
        const delay = i % 2 === 0 ? '0s' : '0.5s'; // alternate delay
        return `
      .bulb-${i} {
        left: ${x}px;
        top: ${y}px;
        animation-delay: ${delay};
        background-color: yellow;
      }
    `;
    }).join('\n')} @keyframes blink {
    0%, 100% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }
}
`;


const CurrentNumber = styled.div`
    font-size: 32px;
    font-weight: bold;
    color: rgb(255, 255, 255);
    margin-bottom: 10px;
    text-align: center;
`;

const CalledNumbers: React.FC = () => {
    const {currentNumber, calledNumbers, gameOver} = useGame();
    const {isMuted} = useMute()

    useEffect(() => {
        if (currentNumber && !gameOver) {
            audioEngine.play(currentNumber, isMuted);
        }
    }, [currentNumber]);


    const lastFiveNumbers: (number | null) [] = [...calledNumbers.slice(-5).reverse()];

    while (currentNumber && lastFiveNumbers.length < 5) {
        lastFiveNumbers.push(null);
    }
    const circleRef = useRef<SVGCircleElement>(null);

    useEffect(() => {
        if (circleRef.current) {
            circleRef.current.style.animation = 'none'; // Reset
            void circleRef.current.getBoundingClientRect(); // Force reflow
            circleRef.current.style.animation = 'ringProgress 4.5s linear forwards'; // Restart
        }
    }, [currentNumber]);


    return (
        <BulbAnimationWrapper2 color={""}>
            <BulbAnimationWrapper>
                <Container>
                    <CurrentNumber>
                        {!currentNumber && 'Waiting for next number...'}
                    </CurrentNumber>
                    {<NumbersRow>
                        {lastFiveNumbers.map((number, index) => (
                            <NumberBubbleWrapper key={index}>
                                <NumberBubble
                                    bg={`./number-${index + 1}.svg`}
                                    isNew={number === currentNumber}
                                    randomColor={getSequentialColor(index)}
                                    isFirst={index === 0}
                                    className={"troika"}
                                >
                                    {number !== null ? (
                                        <>
                                            {number}
                                            <svg viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" r="45" ref={index === 0 ? circleRef : null}
                                                        key={currentNumber + '-' + index}/>
                                            </svg>
                                            <BulbCircle
                                                radius={index === 0 ? 31 : 18}
                                                size={index === 0 ? 100 : 70}
                                                bulbSize={index === 0 ? 5 : 4}
                                                reverse={index % 2 !== 0}
                                                color={getSequentialColor(index).bg}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            {/* Just show the empty bubble with bulb circle */}
                                            <svg viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" r="45"/>

                                            </svg>
                                            <BulbCircle
                                                radius={index === 0 ? 29 : 18}
                                                size={index === 0 ? 100 : 70}
                                                bulbSize={index === 0 ? 5 : 4}
                                                reverse={index % 2 !== 0}
                                                color={getSequentialColor(index).bg}
                                            />
                                        </>
                                    )}
                                </NumberBubble>
                            </NumberBubbleWrapper>
                        ))}

                    </NumbersRow>}
                </Container>
            </BulbAnimationWrapper>
        </BulbAnimationWrapper2>
    );

};

export default CalledNumbers;
